import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import jwtDecode from 'jwt-decode';

const PrivateRoute = ({ component: Component, ...rest }) => {

  interface TokenInfo {
    exp: number;
  }

  function isNotLoginLogin(){
    var expisold = false;
    if(localStorage.getItem("token") != null && localStorage.getItem("token") != "" && localStorage.getItem("token") != undefined && localStorage.getItem("token") != "undefined" && localStorage.getItem("user") != null ){
      const token:string = localStorage.getItem("token")+'';
      const tokende =  jwtDecode<TokenInfo>(token);
      const user:string = localStorage.getItem("user")+'';
      const userObject = JSON.parse(user);
      if( userObject != null && userObject.isClient != null && userObject.isClient) {
        return false;
      } else  if (Date.now() >= tokende.exp * 1000) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  const isLoggedNotIn = isNotLoginLogin();

  return (
    <Route
      {...rest}
      render={props =>
        !isLoggedNotIn ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        )
      }
    />
  )
}

export default PrivateRoute
